import { css } from "@emotion/react";
import { theme } from "styles/theme";
export const HeaderWebsiteStyle = {
  header: css`
    background: #333;
    height: 100px;
  `,
  content: css`
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 100%;
  `,
  left: css`
    display: flex;
    flex-direction: row;
    align-items: center;

    a {
      text-decoration: none;
    }

    .logoApp {
      width: 160px;
      height: 76px;
      object-fit: contain;
      margin-right: 8px;
    }

    .sub-logoApp {
      width: 265px;
      height: 92px;
      object-fit: contain;
    }
  `,
  right: css``,
  right_top: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    .button-custom {
      border-radius: 47px;
      display: flex;
      width: 144px;
      height: 39px;
      text-transform: uppercase;
      padding: 11px 17.3px 8px 17.48px;
      justify-content: center;
      align-items: center;
    }
    .login {
      background-color: ${theme.colors.secondary[650]};
      &:hover {
        background-color: ${theme.colors.secondary[700]};
      }
      border: 0;
      margin-right: 20px;

      span {
        color: ${theme.colors.black};
        font-size: 18px;
        font-weight: bold;
        font-family: Arial, Helvetica, sans-serif;
      }
    }

    .register {
      border-radius: 47px;
      border: 1px solid ${theme.colors.secondary[650]};
      background: transparent;
      margin-right: 20px;
      &:hover {
        border-color: ${theme.colors.secondary[700]} !important;
        span {
          color: ${theme.colors.secondary[700]};
        }
      }

      span {
        color: ${theme.colors.secondary[650]};
        font-size: 18px;
        font-weight: bold;
        font-family: Arial, Helvetica, sans-serif;
      }
    }

    .translate {
      img {
        width: 40px;
        height: 40px;
        object-fit: contain;
      }
    }
  `,
  right_bottom: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    margin-top: 10px;

    .item {
      border-left: 1px solid ${theme.colors.white};
      padding: 0 12px 0 6px;
      cursor: pointer;

      &.no-border {
        border-left: 0;
      }

      span {
        color: ${theme.colors.white};
        font-size: 13px;
        font-weight: 400;
      }
    }

    .item-date {
      .date {
        color: ${theme.colors.white};
        font-size: 12px;
        font-weight: 400;
      }
    }
  `,
  infoProfile: () => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 16px;

    .info {
      color: ${theme.colors.white};
      margin-right: 24px;
      font-size: 14px;
      line-height: 18px;
      p {
        &:nth-of-type(2) {
          display: flex;
          align-items: center;

          gap: 4px;
        }
      }
      .wallet {
        color: #ff9800;
        display: inline-block;
        max-width: 5em;
        overflow: hidden;

        display: flex;
        align-items: center;
        .icon-sync {
          margin-left: 6px;
          cursor: pointer;
        }
      }
    }
    .dropdown {
      width: 120px;
      height: 40px;
      color: #fff;
      font-size: 14px;
      font-weight: bold;
      border: none;
      border-radius: 7px;
      background-color: #ff4435;
      display: flex;
      align-items: center;
      cursor: pointer;
      justify-content: center;
      .icon {
        margin-left: 8px;
      }
      transition: transform 0.3s ease;

      .down {
        transform: rotate(0deg);
        transition: transform 0.3s ease;
      }
      .up {
        transform: rotate(-180deg);
        transition: transform 0.3s ease;
      }
    }
  `,
};
